import { Link } from 'react-router-dom';

import { Menus } from './Menus';

import { SidebarMenu } from '@components/SidebarMenu';

interface Props {
  onClose: () => void;
}

export const SideBarResponsive: React.FC<Props> = ({ onClose }) => {
  return (
    <>
      <div className="grid gap-y-10 px-5 py-8">
        {Menus.map((menu) => {
          const Icon = menu.icon;
          const hasSubMenu =
            Array.isArray(menu.subMenu) && menu.subMenu.length > 0;
          const mainMenu = menu.mainMenu.replace(/\s+/g, '-').toLowerCase();

          return (
            <>
              {hasSubMenu ? (
                <SidebarMenu
                  key={mainMenu}
                  subMenuActions={
                    menu.subMenu?.map((sub) => ({
                      title: sub.subMenu,
                      to: sub.subMenuRoutes,
                      onClick: onClose,
                    })) || []
                  }
                >
                  <Icon className="w-6 text-primary-500" />
                </SidebarMenu>
              ) : (
                <Link to={menu.route || ''} onClick={() => onClose()}>
                  <Icon className="w-6 text-primary-500" />
                </Link>
              )}
            </>
          );
        })}
      </div>
    </>
  );
};
